var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-empty',{attrs:{"description":"セッションエラーが発生しました"}},[_c('router-link',{attrs:{"to":_vm.routes.Login}},[_vm._v("ログイン画面へ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }